import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import './SellProjectedDate.scss';

import ToolTip from '../../../Shared/ToolTip/ToolTip';
import { formatUnixDate } from '../../../../utils/dates/date-utility';
import {
  isCollegeDistribute,
  isAppSell,
  isSell,
} from '../../../../utils/transactions-util';
import { currency } from '../../../../utils/utils';
import iconHelp from 'src/assets/images/icon_help.svg';
import {
  openModal as openModalAction,
  APP_TRADE_DATE,
} from 'src/redux/modules/modals/modals.module';

const SellProjectedDate = ({
  displayTradeDate,
  isTakeHomeEstimated,
  openModal,
  sellTakeHomeAmount,
  sellTotalAmount,
}) => {
  return (
    <div className="sell-projected-date">
      {isSell() ? (
        <div className="col-md-5 col-sm-6 sell-projected-date-projected-date" />
      ) : !isAppSell() ? (
        <div className="col-md-5 col-sm-6 sell-projected-date-projected-date">
          Projected Trade Date:
          <span className="sell-projected-date-take-home-amount">
            {formatUnixDate(displayTradeDate)}{' '}
          </span>
          <span>
            <ToolTip
              message={
                'For most funds, trades received after the close of regular trading on the New York Stock Exchange (usually 4 p.m. ET) will be priced at the next business day’s close.  For Government Money Fund and U.S. Treasury Money Fund, trades in and out of these funds and exchanges solely between these funds received after the fund’s close (normally 5 p.m. ET) will be priced at the next business day’s close.'
              }
            />
          </span>
        </div>
      ) : (
        <div className="col-md-5 col-sm-6 sell-projected-date-projected-date">
          Projected Trade Date
          <span>
            <a
              className="sell-projected-date-take-home-amount"
              onClick={() => openModal(APP_TRADE_DATE)}
            >
              <img
                id="balance-tooltip-icon"
                alt="help"
                className="sell-landing-balance-tooltip-icon"
                src={iconHelp}
              />
            </a>
          </span>
        </div>
      )}
      <div className="sell-projected-date-mobile-row">
        <div className="col-md-5 col-sm-4 sell-projected-date-total-take-home">
          {isTakeHomeEstimated ? 'Est.' : ''}
          {isCollegeDistribute() ? (
            <span>Total</span>
          ) : (
            <span>
              <span className="hidden-sm hidden-xs"> Total </span> Take-Home
              Amount{' '}
            </span>
          )}
        </div>
        <div className="col-md-2 col-sm-2 sell-projected-date-take-home-amount sell-projected-date-space">
          {isCollegeDistribute()
            ? currency(sellTotalAmount)
            : currency(sellTakeHomeAmount)}
        </div>
      </div>
    </div>
  );
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      openModal: openModalAction,
    },
    dispatch
  );

export default connect(null, mapDispatchToProps)(SellProjectedDate);
